import { axiosClient } from '../axiosClient';
import type { Device, DeviceDetails } from '@/types/device.types';

interface GetDevicesParams {
  platform?: string;
  osVersion?: string;
  status?: string;
  page?: number;
  limit?: number;
}

interface GetDevicesResponse {
  devices: Device[];
  total: number;
  page: number;
  limit: number;
}

export const getDevices = async (params?: GetDevicesParams): Promise<GetDevicesResponse> => {
  try {
    const response = await axiosClient.get('/devices', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch devices:', error);
    throw error;
  }
};

export const getDeviceById = async (id: string): Promise<DeviceDetails> => {
  try {
    const response = await axiosClient.get(`/devices/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch device ${id}:`, error);
    throw error;
  }
};

export const getDeviceActivity = async () => {
  try {
    const response = await axiosClient.get('/dashboard/device-activity');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch device activity:', error);
    throw error;
  }
};

export const getRecentDevices = async (limit = 10) => {
  try {
    const response = await axiosClient.get('/dashboard/recent-devices', {
      params: { limit },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch recent devices:', error);
    throw error;
  }
};
